export default "__VITE_ASSET__a35da4a9__"